import {
  FETCH_ALL_INVOICE_FAILURE,
  FETCH_ALL_INVOICE_REQUEST,
  FETCH_ALL_INVOICE_SUCCESS,
  FETCH_CUSTOMER_ALL_INVOICE_FAILURE,
  FETCH_CUSTOMER_ALL_INVOICE_REQUEST,
  FETCH_CUSTOMER_ALL_INVOICE_SUCCESS,
  FETCH_INVOICE_FAILURE,
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICE_VIEWS_FAILURE,
  FETCH_INVOICE_VIEWS_REQUEST,
  FETCH_INVOICE_VIEWS_SUCCESS,
  FETCH_VENDOR_ALL_INVOICE_FAILURE,
  FETCH_VENDOR_ALL_INVOICE_REQUEST,
  FETCH_VENDOR_ALL_INVOICE_SUCCESS,
  RESET_INVOICE_DETAILS,
} from './InvoiceType';

export const fetchInvoiceRequest = (invoiceId) => ({
  type: FETCH_INVOICE_REQUEST,
  payload: invoiceId,
});

export const fetchInvoiceSuccess = (invoice) => ({
  type: FETCH_INVOICE_SUCCESS,
  payload: invoice,
});

export const fetchInvoiceFailure = (error) => ({
  type: FETCH_INVOICE_FAILURE,
  payload: error,
});

export const fetchAllInvoicesRequest = (payload) => {
  return {
    type: FETCH_ALL_INVOICE_REQUEST,
    payload
  };
};

export const fetchAllInvoicesSuccess = (invoices) => {
  return {
    type: FETCH_ALL_INVOICE_SUCCESS,
    payload: invoices,
  };
};

export const fetchAllInvoicesFailure = (error) => ({
  type: FETCH_ALL_INVOICE_FAILURE,
  payload: error,
});


export const fetchInvoiceViewsRequest = (payload) => {
  return {
    type: FETCH_INVOICE_VIEWS_REQUEST,
  };
};

export const fetchInvoiceViewsSuccess = (invoices) => {
  return {
    type: FETCH_INVOICE_VIEWS_SUCCESS,
    payload: invoices,
  };
};

export const fetchInvoiceViewsFailure = (error) => ({
  type: FETCH_INVOICE_VIEWS_FAILURE,
  payload: error,
});

export const fetchCustomerInvoicesRequest = (payload) => {
  return {
    type: FETCH_CUSTOMER_ALL_INVOICE_REQUEST,
    payload,
  };
};

export const fetchCustomerInvoicesSuccess = (invoices) => ({
  type: FETCH_CUSTOMER_ALL_INVOICE_SUCCESS,
  payload: invoices,
});

export const fetchCustomerInvoicesFailure = (error) => ({
  type: FETCH_CUSTOMER_ALL_INVOICE_FAILURE,
  payload: error,
});

export const fetchVendorInvoicesRequest = (payload) => {

  return {
    type: FETCH_VENDOR_ALL_INVOICE_REQUEST,
    payload,
  };
};

export const fetchVendorInvoicesSuccess = (invoices) => ({
  type: FETCH_VENDOR_ALL_INVOICE_SUCCESS,
  payload: invoices,
});

export const fetchVendorInvoicesFailure = (error) => ({
  type: FETCH_VENDOR_ALL_INVOICE_FAILURE,
  payload: error,
});
export const resetInvoiceDetails = () => ({
  type: RESET_INVOICE_DETAILS,
});

